import React, { useEffect, useState } from "react";
import "./FilaMensagens.css";

const formatarDataBrasil = (dataISO) => {
  if (!dataISO) return "Data Inválida";
  if (dataISO.includes("/")) return dataISO;
  const [data, hora] = dataISO.split(" ");
  const [ano, mes, dia] = data.split("-");
  return hora ? `${dia}/${mes}/${ano} ${hora}` : `${dia}/${mes}/${ano}`;
};

function FilaMensagens() {
  const [fila, setFila] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtros, setFiltros] = useState({ texto: "", status: "", nome: "", inicio: "", fim: "" });
  const [selecionados, setSelecionados] = useState([]);

  const fetchFila = async () => {
    try {
      const res = await fetch("https://welaunchyou.com.br/crm-wly/api/whatsapp/fila_mensagens.php", {
        credentials: "include",
      });
      const data = await res.json();
      if (data.success) {
        setFila(data.fila);
      }
    } catch (error) {
      console.error("Erro de conexão:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFila();
    const intervalo = setInterval(fetchFila, 10000);
    return () => clearInterval(intervalo);
  }, []);

  const handleFiltroChange = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const filtrar = (item) => {
    const msgMatch = item.mensagem?.toLowerCase().includes(filtros.texto.toLowerCase());
    const statusMatch = filtros.status ? item.status === filtros.status : true;
    const nomeMatch = filtros.nome ? (item.nome_lead || '').toLowerCase().includes(filtros.nome.toLowerCase()) : true;
    const dataCriada = item.criado_em.split(' ')[0];
    const inicioOk = filtros.inicio ? dataCriada >= filtros.inicio : true;
    const fimOk = filtros.fim ? dataCriada <= filtros.fim : true;
    return msgMatch && statusMatch && nomeMatch && inicioOk && fimOk;
  };

  const listaFiltrada = fila.filter(filtrar);

  const toggleSelecionado = (id) => {
    setSelecionados((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);
  };

  const toggleTodosSelecionados = (e) => {
    if (e.target.checked) {
      setSelecionados(listaFiltrada.map((item) => item.id));
    } else {
      setSelecionados([]);
    }
  };

  const excluirMensagem = async (id) => {
    if (!window.confirm("Tem certeza que deseja excluir esta mensagem da fila?")) return;
    try {
      const res = await fetch("/crm-wly/api/whatsapp/fila_mensagens.php", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id })
      });
      const data = await res.json();
      if (data.success) setFila(prev => prev.filter(msg => msg.id !== id));
    } catch (err) {
      alert("Erro de conexão.");
    }
  };

const excluirSelecionados = async () => {
  if (!window.confirm(`Deseja realmente excluir ${selecionados.length} mensagens selecionadas?`)) return;

  for (const id of selecionados) {
    try {
      const res = await fetch("/crm-wly/api/whatsapp/fila_mensagens.php", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id })
      });
      const data = await res.json();
      if (data.success) {
        setFila((prev) => prev.filter((msg) => msg.id !== id));
      }
    } catch (err) {
      console.error("Erro ao excluir ID " + id);
    }
  }

  setSelecionados([]);
};


const reenviarMensagem = async (id) => {
  if (!window.confirm(`Deseja reenviar a mensagem ID ${id}?`)) return;

  try {
    const res = await fetch("/crm-wly/api/whatsapp/fila_mensagens.php", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, acao: "reenviar" })
    });

    const data = await res.json();
    if (data.success) {
      fetchFila(); // recarrega a lista para exibir a nova mensagem criada
    } else {
      alert(data.message || "Erro ao reenviar.");
    }
  } catch (err) {
    alert("Erro de conexão.");
  }
};


const reenviarSelecionados = async () => {
  if (!window.confirm(`Deseja reenviar ${selecionados.length} mensagens selecionadas?`)) return;

  for (const id of selecionados) {
    try {
      const res = await fetch("/crm-wly/api/whatsapp/fila_mensagens.php", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, acao: "reenviar" })
      });
      const data = await res.json();
      if (!data.success) {
        console.warn(`Falha ao reenviar mensagem ID ${id}: ${data.message}`);
      }
    } catch (err) {
      console.error("Erro ao reenviar ID " + id);
    }
  }

  fetchFila(); // recarrega a lista com as novas inserções
  setSelecionados([]);
};


  const editarMensagem = (id, novaMensagem) => {
    setFila((prev) => prev.map((msg) => (msg.id === id ? { ...msg, mensagem: novaMensagem } : msg)));
  };

  const salvarMensagem = async (id) => {
    const mensagem = fila.find((m) => m.id === id)?.mensagem;
    try {
            await fetch("/crm-wly/api/whatsapp/fila_mensagens.php", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ acao: "atualizar", id, mensagem })
      });

    } catch (err) {
      alert("Erro ao salvar mensagem editada.");
    }
  };

  return (
    <div className="fila-mensagens-container">
      <h2 style={{ borderBottom: "none" }}>Fila de Mensagens do WhatsApp</h2>

      <div className="filtros-fila">
        <input name="texto" type="text" placeholder="Filtrar mensagem..." onChange={handleFiltroChange} />
        <input name="nome" type="text" placeholder="Filtrar por nome..." onChange={handleFiltroChange} />
        <select name="status" onChange={handleFiltroChange} defaultValue="">
          <option value="">Todos os status</option>
          <option value="pendente">Pendente</option>
          <option value="enviado">Enviado</option>
          <option value="erro">Erro</option>
        </select>
        <input name="inicio" type="date" onChange={handleFiltroChange} />
        <input name="fim" type="date" onChange={handleFiltroChange} />
      </div>

      {loading ? (
        <p>Carregando fila...</p>
      ) : listaFiltrada.length === 0 ? (
        <p>Nenhuma mensagem encontrada.</p>
      ) : (
        <table className="fila-tabela">
          <thead>
            <tr>
              <th><input type="checkbox" onChange={toggleTodosSelecionados} /></th>
              <th>ID</th>
              <th>Nome</th>
              <th>Telefone</th>
              <th>Mensagem</th>
              <th>Status</th>
              <th>Tentativas</th>
              <th>Envio</th>
              <th>Agendado</th>
              <th>Delay (seg)</th>
              <th>Usuário</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {listaFiltrada.map((item) => (
              <tr key={item.id}>
                <td><input type="checkbox" checked={selecionados.includes(item.id)} onChange={() => toggleSelecionado(item.id)} /></td>
                <td>{item.id}</td>
                <td>{item.nome_lead || "-"}</td>
                <td>{item.telefone}</td>
                <td>
                  {item.status !== "enviado" ? (
                    <input
                      type="text"
                      value={item.mensagem}
                      onChange={(e) => editarMensagem(item.id, e.target.value)}
                      onBlur={() => salvarMensagem(item.id)}
                      className="input-msg-editavel"
                    />
                  ) : (
                    <>{item.mensagem.slice(0, 40)}{item.mensagem.length > 40 && '...'}</>
                  )}
                </td>
                <td className={`status-${item.status}`} title={item.resposta_api || ''}> {item.status}</td>
                <td>{item.tentativas}</td>
                <td>
                  {item.status === "pendente" && <img src="/crm-wly/uploads/svg/agendado.png" className="btn-icone" alt="Agendado"/>}
                  {item.status === "enviado" && <img src="/crm-wly/uploads/svg/entregue.png" className="btn-icone" alt="Enviado"  />}
                  {item.status === "erro" && <img src="/crm-wly/uploads/svg/erro.png" className="btn-icone" alt="Erro"/>}
                  {item.enviado_em ? formatarDataBrasil(item.enviado_em) : "-"}
                </td>
                <td>{item.agendado_em ? formatarDataBrasil(item.agendado_em) : "-"}</td>
                <td>{item.delay_envio}</td>
                <td>{item.nome_empresa || "-"}</td>
                <td>
                  {item.status !== "enviado" && (
                    <div className="acoes-botoes">
                      <button onClick={() => reenviarMensagem(item.id)} title="Reenviar" className="btn-acoes">
                        <img src="/crm-wly/uploads/svg/reenviar.png" alt="Reenviar" />
                      </button>
                      <button onClick={() => excluirMensagem(item.id)} title="Excluir" className="btn-acoes">
                        <img src="/crm-wly/uploads/svg/lixeira.png" alt="Excluir" />
                      </button>
                    </div>
                  )}
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      )}

            {selecionados.length > 0 && (
        <div className="acoes-selecao">
          <button onClick={reenviarSelecionados}>Reenviar selecionados</button>
          <button onClick={excluirSelecionados}>Excluir selecionados</button>          
        </div>
      )}

    </div>
  );
}

export default FilaMensagens;
